/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Close_Window_LogInputs */

const en_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### You can close this window now. ###`)
};

const fr_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### Vous pouvez fermer cette fenetre maintenant. ###`)
};

const de_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### Sie können dieses Fenster jetzt schließen. ###`)
};

const it_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### Ora puoi chiudere questa finestra. ###`)
};

const ru_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### Теперь вы можете закрыть это окно. ###`)
};

const es_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### Puedes cerrar esta ventana ahora. ###`)
};

const zh_cn2_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您现在可以关闭此窗口了。`)
};

const ja_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### このウィンドウは閉じて構いません。 ###`)
};

const hi_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`### अब आप इस विंडो को बंद कर सकते हैं। ###`)
};

const pt_pt2_drastic_tech_close_window_log = /** @type {(inputs: Drastic_Tech_Close_Window_LogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode fechar esta janela agora.`)
};

/**
* | output |
* | --- |
* | "### You can close this window now. ###" |
*
* @param {Drastic_Tech_Close_Window_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_close_window_log = /** @type {((inputs?: Drastic_Tech_Close_Window_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Close_Window_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_close_window_log(inputs)
	if (locale === "de") return de_drastic_tech_close_window_log(inputs)
	if (locale === "it") return it_drastic_tech_close_window_log(inputs)
	if (locale === "ru") return ru_drastic_tech_close_window_log(inputs)
	if (locale === "es") return es_drastic_tech_close_window_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_close_window_log(inputs)
	if (locale === "ja") return ja_drastic_tech_close_window_log(inputs)
	if (locale === "hi") return hi_drastic_tech_close_window_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_close_window_log(inputs)
	return en_drastic_tech_close_window_log(inputs)
});